module.exports = __webpack_public_path__ + "img/2.8d9d22d1.svg";